module.exports = __webpack_public_path__ + "static/media/lohono-logo-gold.f1e926e5.svg";